'use client';

import { ReactNode, useState } from 'react';
import { Button, IconButton, ListItemIcon, Menu, MenuItem } from '@/primitives';
import { alpha } from '@mui/material/styles';
import MoreVert from '@mui/icons-material/MoreVert';

export interface Action {
  icon?: ReactNode;
  label: string | ReactNode;
  action: () => void;
  disabled?: boolean;
}

export interface DropdownActionsProps {
  actions: Action[];
}

export function DropdownActions({ actions }: DropdownActionsProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action: () => void) => {
    action();
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          borderColor: (theme) => alpha(theme.palette.primary.main, 0.5),
          borderWidth: 1,
          borderStyle: 'solid',
          borderRadius: '5px',
          ':hover': {
            borderColor: (theme) => theme.palette.primary.main,
          },
        }}
      >
        <MoreVert color="primary" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {actions.map((action, index) => (
          <MenuItem
            disabled={action.disabled || false}
            key={index}
            onClick={() => handleMenuItemClick(action.action)}
          >
            <ListItemIcon>{action.icon}</ListItemIcon>
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
